export { useUser, UserProvider } from "./UserContext";
export { useMerchant, usePaymentSettings, MerchantProvider } from "./MerchantContext";
export { AuthGuard, TokenGuard } from "./AuthGuard";
export { UserGuard } from "./UserGuard";
export { MerchantGuard } from "./MerchantGuard";
export { default as LogoutPage } from "./LogoutPage";
export { PermissionsGuard } from "./PermissionsGuard";

// Permissions
export const updateUser = "update:user";
export const updateMerchant = "update:merchant";
export const readCardPayout = "read:cardpayout";

export const readPaymentRequestBranch = "read:paymentrequest:branch";
export const readPaymentRequestMerchant = "read:paymentrequest:merchant";

export const readPayment = "read:payment";
export const updatePayment = "update:payment";

export const readCustomer = "read:customer";
export const updateCustomer = "update:customer";

export const readLedgerPayment = "read:ledgerpayment";
export const updateLedgerPayment = "update:ledgerpayment";

export const readMessageTemplate = "read:messagetemplate";
export const updateMessageTemplate = "update:messagetemplate";

export const canUpdatePaymentRequestTemplate = "update:paymentrequesttemplate";

export const canUseAi = "use:ai";
